import { orderByName } from "../../../../../../libs/orderList";
import { serviceUsers } from "../../../../../Collaborator/service";
import { getEletronicById } from "../../service";
import { IEletronicInventory } from "../models";
import { verefyStateOfResponsabilityOfNumber } from "./libsGeral";

export async function getUsers(setListusers, token) {
  const data = await serviceUsers.getUsers(token);
  const dataOrder = orderByName(data, "name");
  setListusers(dataOrder || data);
}

export async function getInventoryEletronicById(token, params, setCreateOrUpdate, setNeedSpinner, setState, setDefaultValues, setFile) {
  const data = await getEletronicsById(token, params);
  dataExist(data, setCreateOrUpdate, setNeedSpinner);
  const stateOfResponsability = convertStateOfResponsability(data);
  setNewValues(setState, data, setDefaultValues, stateOfResponsability);
  setFile(data?.urlStatement);
  setTimeout(() => {
    setNeedSpinner(false);
  }, 500);
}

async function getEletronicsById(token, params) {
  const data = await getEletronicById(token, params);
  return data;
}

function dataExist(data, setCreateOrUpdate, setNeedSpinner) {
  if (data) return;
  setCreateOrUpdate("create");
  return setNeedSpinner(false);
}

function convertStateOfResponsability(data: any) {
  const stateOfResponsability: IEletronicInventory = {
    ...data,
    statementOfResponsibility: verefyStateOfResponsabilityOfNumber(data?.statementOfResponsibility),
  };
  return stateOfResponsability;
}

function setNewValues(setState, data, setDefaultValues, stateOfResponsability) {
  setState(data?.isDeleted);
  setDefaultValues(stateOfResponsability);
}
